import { ActionWithPayload } from "@obg/ngrx-utils";

import { BALANCE_LIMIT_ACTION_TYPE } from "./balance-limit.action";
import { BalanceLimitState } from "./balance-limit.model";

const INITIAL_STATE: BalanceLimitState = {};

export function balanceLimitReducer(state = INITIAL_STATE, action: ActionWithPayload): BalanceLimitState {
	switch (action.type) {
		case BALANCE_LIMIT_ACTION_TYPE.getSuccess: {
			return action.payload;
		}
		case BALANCE_LIMIT_ACTION_TYPE.reset:
			return INITIAL_STATE;
		default:
			return state;
	}
}
